import React, { useEffect } from 'react';
import classes from './ModalAddCredential.module.scss';
import { ModalOutProps } from 'new/routes/ModalDefault';
import { useSelector } from 'react-redux';
import { ModalConfig } from 'new/routes/RouterManager';
import {
  Checkbox,
  Table as MuiTable,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { PROBE_GET_SAMPLE_REQUEST } from 'js/constants/actionTypes';
import cx from 'classnames';
import Typography from 'new/elements/Typography';

interface ModalPreviewSamplesProps {
  credentialId?: number;
}

export const ModalPreviewSamples = (props: ModalPreviewSamplesProps & Partial<ModalOutProps>) => {
  const { setLoading, credentialId } = props;
  const probe = useSelector((state: any) => state.probe);
  const output = probe[credentialId]?.[0]?.response?.output;
  const samples: { data: any[]; columns: string[] } = output?.response;
  const errorMessage: string = output?.errorMessage;
  const loading = useIsLoading(PROBE_GET_SAMPLE_REQUEST);

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  return (
    <div className={classes.modalContainer}>
      {!!errorMessage ? (
        <Typography variant="h5">{errorMessage}</Typography>
      ) : (
        <MuiTable
          size="small"
          className={cx(classes.table, { [classes.table_invisible]: loading })}
        >
          <TableHead>
            <TableRow>
              {samples?.columns?.map((column) => (
                <TableCell key={column}>{column}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {React.Children.toArray(
              samples?.data?.map((row) => (
                <TableRow>
                  {samples?.columns?.map((column) => (
                    <TableCell key={row[column]} component="th" scope="row">
                      {row[column]}
                    </TableCell>
                  ))}
                </TableRow>
              )),
            )}
          </TableBody>
        </MuiTable>
      )}
    </div>
  );
};

ModalPreviewSamples.modalConfig = {
  name: 'ModalPreviewSamples',
  title: 'Preview samples',
} as ModalConfig;
